import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import RoundButton from 'components/Buttons/RoundButton';
import { ArrowAngleLeft, Cross } from 'components/Icon';

import { FullScreenModalHeaderPropsType } from './types';

import * as S from './styled';

const FullScreenModalHeader = ({ onBackButtonClick, closeModal }: FullScreenModalHeaderPropsType) => {
    const { t } = useTranslation();

    return (
        <S.FullScreenModalHeader>
            <div>
                {onBackButtonClick && (
                    <RoundButton
                        onClick={onBackButtonClick}
                        dataLocator="subscriptionModalBackButton"
                        dataTestId="subscriptionModalBackButton"
                    >
                        <ArrowAngleLeft />
                    </RoundButton>
                )}
            </div>
            <Text medium color="text-main" type="large-text" center>
                {t('subscription.discountOfferModal.headerTitle')}
            </Text>
            <RoundButton
                onClick={closeModal}
                dataLocator="subscriptionModalCloseButton"
                dataTestId="subscriptionModalCloseButton"
            >
                <Cross />
            </RoundButton>
        </S.FullScreenModalHeader>
    );
};

export default FullScreenModalHeader;
